import Modal from 'components/global/Modal'
import { Col, Row } from 'components/grid'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'

interface Props {
	infoText: IGatsbyImageData
	hookBook: IGatsbyImageData
}

const PairedCoreTexts = ({ infoText, hookBook }: Props) => {
	const [show, setShow] = React.useState(false)
	const handleClose = () => setShow(false)
	const handleShow = () => setShow(true)

	const data = useStaticQuery(graphql`
		query {
			contentfulModal(name: { eq: "Paired Core Texts" }) {
				title
				description {
					description
				}
			}
		}
	`)

	const title = data.contentfulModal.title
	const description = data.contentfulModal.description.description

	return (
		<React.Fragment>
			<button onClick={handleShow} className="h-full flex flex-col">
				<div className="flex flex-wrap sm:flex-nowrap">
					<GatsbyImage
						image={hookBook}
						alt={title}
						className="mx-auto w-auto transform hover:scale-105 transition ease-in-out duration-200"
						style={{ maxHeight: 250 }}
						objectFit="contain"
					/>
					<GatsbyImage
						image={infoText}
						alt={title}
						className="mx-auto w-auto transform hover:scale-105 transition ease-in-out duration-200"
						style={{ maxHeight: 250 }}
						objectFit="contain"
					/>
				</div>
				<div className="pt-4 mt-auto">
					<span className="inline-block w-full text-xl font-semibold text-center hover:underline">{title}</span>
				</div>
			</button>
			<Modal title={title} isOpen={show} handleClose={handleClose}>
				<Row>
					<Col>
						<p className="text-slate-400 text-lg">{description}</p>
					</Col>
					<Col width="w-1/2" className="text-center">
						<GatsbyImage image={hookBook} alt={title} />
						<h5>Fiction Hook Book</h5>
					</Col>
					<Col width="w-1/2" className="text-center">
						<GatsbyImage image={infoText} alt={title} />
						<h5>Related Informational Text</h5>
					</Col>
				</Row>
			</Modal>
		</React.Fragment>
	)
}

export default PairedCoreTexts
